import { Box, Typography, Container } from "@mui/material";
import { ServerNews } from "../server-news";

export const ServerNewsPage = () => {
    return (
        <Box
            sx={{
                position: "relative",
                overflow: "hidden",
                minHeight: "100vh",
                py: { xs: 5, sm: 7, md: 10 },
                background:
                    "radial-gradient(circle at 50% -10%, rgba(57,217,138,0.16), transparent 35%), radial-gradient(circle at 100% 45%, rgba(57,217,138,0.045), transparent 30%), linear-gradient(180deg, #06120A 0%, #08150D 55%, #030805 100%)",
                fontFamily: "'Poppins', sans-serif",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "65%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(57,217,138,0.8), transparent)",
                },
            }}
        >
            {/* =========================================================
                TOP EMERALD GLOW
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-280px",
                    right: "-280px",
                    width: "700px",
                    height: "700px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.11) 0%, transparent 68%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />

            {/* =========================================================
                BOTTOM EMERALD GLOW
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: "-320px",
                    left: "-320px",
                    width: "750px",
                    height: "750px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.055) 0%, transparent 68%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />

            {/* =========================================================
                CENTER AMBIENT GLOW
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "38%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "600px",
                    height: "600px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.035), transparent 70%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />

            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* =====================================================
                    HEADER
                ====================================================== */}
                <Box
                    sx={{
                        textAlign: "center",
                        mb: {
                            xs: 5,
                            md: 7,
                        },
                    }}
                >
                    <Typography
                        sx={{
                            color: "#39D98A",
                            fontWeight: 800,
                            letterSpacing: "4px",
                            fontSize: "11px",
                            mb: 1.5,
                            textTransform: "uppercase",
                            textShadow:
                                "0 0 20px rgba(57,217,138,0.2)",
                        }}
                    >
                        Critical Conquer • News Center
                    </Typography>

                    <Typography
                        sx={{
                            color: "#fff",
                            fontWeight: 900,
                            fontSize: {
                                xs: "40px",
                                sm: "50px",
                                md: "64px",
                            },
                            lineHeight: 1,
                            letterSpacing: "-1px",
                            mb: 2.5,
                            textShadow:
                                "0 5px 30px rgba(0,0,0,0.55)",
                        }}
                    >
                        Server{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "#39D98A",
                                textShadow:
                                    "0 0 30px rgba(57,217,138,0.25)",
                            }}
                        >
                            Updates
                        </Box>
                    </Typography>

                    {/* DECORATIVE EMERALD LINE */}
                    <Box
                        sx={{
                            width: 90,
                            height: 3,
                            borderRadius: "10px",
                            background:
                                "linear-gradient(90deg, transparent, #39D98A, transparent)",
                            mx: "auto",
                            mt: 3,
                            boxShadow:
                                "0 0 18px rgba(57,217,138,0.2)",
                        }}
                    />
                </Box>

                {/* =====================================================
                    NEWS CONTENT
                ====================================================== */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,

                        /*
                         * The actual ServerNews component is untouched.
                         * These styles only help surrounding content
                         * visually blend into the Critical Conquer theme.
                         */
                        "& > *": {
                            position: "relative",
                        },
                    }}
                >
                    <ServerNews />
                </Box>

                {/* =====================================================
                    BOTTOM BRAND ACCENT
                ====================================================== */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 2,
                        mt: {
                            xs: 5,
                            md: 7,
                        },
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 75,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(57,217,138,0.35))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "rgba(155,255,196,0.4)",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Critical Conquer
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 75,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(57,217,138,0.35), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};